import { Menu } from "@mantine/core";
import { EditMenuItemProps } from "./types";
import { ModalComponent } from "components";

import { useModals } from "@mantine/modals";
import { useTableProvider } from "../../providers";

export function EditMenuItem(props: EditMenuItemProps) {
  const { brand } = props;

  const modals = useModals();
  const { refreshTable } = useTableProvider();

  function handleClick() {
    modals.openContextModal("brand.edit", {
      title: <ModalComponent.Title>Edit Brand</ModalComponent.Title>,
      innerProps: {
        brand: brand,
        onSubmit: async () => await refreshTable(),
      },
    });
  }

  return <Menu.Item onClick={handleClick}>Change Name</Menu.Item>;
}
